import ToggleOverpaymentsStatus from './toggle-overpayement-status';
import {MODAL} from 'features/modal-notch/constants';

export default {
  [MODAL.TOGGLE_STATUS_OVERPAYEMENT]: ToggleOverpaymentsStatus,
};
